import store from "../app/store";
import {
  removeBidAdminEvent,
  removeBidEmpEvent,
  removeFreezeEvent,
  removeNotificationEvent,
  removeScheduleAdminEvent,
  removeTaedAdminEvent,
  removeTorAdminEvent,
  removeTorEmpEvent,
  removeTradeAdminEvent,
  removeTradeEmpEvent,
} from "../slices/webSocketEvent/webSocketEventSlice";
import { getScrubbedBidEvent } from "./bid/bidScrubber";
import { SCHEDULE_UPDATE_TYPE } from "./schedule/scheduleConstants";
import { convertIncomingTaedEventToSnapshotFormat } from "./taed/tempAssignmentScrubber";
import { convertIncomingTorEventToSnapshotFormat } from "./timeOffRequestScrubber";
import { getScrubbedTradeFormEvent } from "./tradeFormEventScrubber";

export const mergeWebSocketEmpTrades = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, tradeWsEvent] of Object.entries(webSocketData)) {
    let newTrade = getScrubbedTradeFormEvent(tradeWsEvent);
    let idx = data.findIndex((trade) => trade.tradeFormId === newTrade.tradeFormId);
    if (idx !== -1) {
      if (newTrade.createdAt.toMillis() > data[idx].createdAt.toMillis()) {
        data[idx] = newTrade;
      }
    } else {
      data.unshift(newTrade);
    }
    store.dispatch(removeTradeEmpEvent(key));
  }
  return data;
};

export const mergeWebSocketAdminTrades = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, tradeWsEvent] of Object.entries(webSocketData)) {
    let newTrade = getScrubbedTradeFormEvent(tradeWsEvent);
    let idx = data.findIndex((trade) => trade.tradeFormId === newTrade.tradeFormId);
    if (idx !== -1) {
      if (newTrade.createdAt.toMillis() > data[idx].createdAt.toMillis()) {
        data[idx] = newTrade;
      }
    } else {
      data.unshift(newTrade);
    }
    store.dispatch(removeTradeAdminEvent(key));
  }
  return data;
};

export const mergeWebSocketEmpTORs = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, torWsEvent] of Object.entries(webSocketData)) {
    let newTor = convertIncomingTorEventToSnapshotFormat(torWsEvent);
    let idx = data.findIndex((tor) => tor.torId === newTor.torId);
    if (idx !== -1) {
      if (newTor.lastUpdatedDate.ts > data[idx].lastUpdatedDate.ts) {
        data[idx] = newTor;
      }
    } else {
      data.unshift(newTor);
    }
    store.dispatch(removeTorEmpEvent(key));
  }
  return data;
};

export const mergeWebSocketAdminTORs = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, torWsEvent] of Object.entries(webSocketData)) {
    let newTor = convertIncomingTorEventToSnapshotFormat(torWsEvent);
    let idx = data.findIndex((tor) => tor.torId === newTor.torId);
    if (idx !== -1) {
      if (newTor.lastUpdatedDate.ts > data[idx].lastUpdatedDate.ts) {
        data[idx] = newTor;
      }
    } else {
      data.unshift(newTor);
    }
    store.dispatch(removeTorAdminEvent(key));
  }
  return data;
};

export const mergeWebSocketAdminTAEDs = (webSocketData, station, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, taedWsEvent] of Object.entries(webSocketData)) {
    let newTaed = convertIncomingTaedEventToSnapshotFormat(taedWsEvent, station);
    let idx = data.findIndex((taed) => taed.referenceNumber === newTaed.referenceNumber);
    if (idx !== -1) {
      if (newTaed.lastUpdatedDate.ts > data[idx].lastUpdatedDate.ts) {
        data[idx] = newTaed;
      }
    } else {
      data.unshift(newTaed);
    }
    store.dispatch(removeTaedAdminEvent(key));
  }
  return data;
};

export const mergeWebSocketAdminBids = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, bidWsEvent] of Object.entries(webSocketData)) {
    let newBid = getScrubbedBidEvent(bidWsEvent);
    let idx = data.findIndex((bid) => bid.referenceNumber === newBid.referenceNumber);
    if (idx !== -1) {
      if (newBid.createdAt.toMillis() > data[idx].createdAt.toMillis()) {
        data[idx] = newBid;
      }
    } else {
      data.unshift(newBid);
    }
    store.dispatch(removeBidAdminEvent(key));
  }
  return data;
};

export const mergeWebSocketEmpBidChoices = (webSocketData, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, bidChoiceWsEvent] of Object.entries(webSocketData)) {
    let newBidChoice = getScrubbedBidEvent(bidChoiceWsEvent);
    let idx = data.findIndex((bidChoice) => bidChoice.referenceNumber === newBidChoice.referenceNumber);
    if (idx !== -1) {
      if (newBidChoice.createdAt.toMillis() > data[idx].createdAt.toMillis()) {
        data[idx] = newBidChoice;
      }
    } else {
      data.unshift(newBidChoice);
    }
    store.dispatch(removeBidEmpEvent(key));
  }
  return data;
};

export const mergeWebSocketSchedules = (webSocketData, station, eid, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, scheduleWsEvent] of Object.entries(webSocketData)) {
    // Process only if the event is for the same station and employee id admin has selected
    if (scheduleWsEvent.station === station && scheduleWsEvent.eid === eid) {
      const idx = data.findIndex(
        (schedule) => schedule.sk === scheduleWsEvent.sk && schedule.pk === scheduleWsEvent.pk
      );
      if (idx !== -1) {
        const matchingSchedule = data[idx];
        // Condition to replace element in array if it already exists (update)
        if (parseInt(scheduleWsEvent.createdAt) > parseInt(matchingSchedule.createdAt)) {
          if (scheduleWsEvent.updateType !== SCHEDULE_UPDATE_TYPE.DELETE) {
            data[idx] = scheduleWsEvent;
          } else {
            data.splice(idx, 1);
          }
        }
      } else if (scheduleWsEvent.updateType !== SCHEDULE_UPDATE_TYPE.DELETE) {
        // New record
        data.unshift(scheduleWsEvent);
      }
    }
    store.dispatch(removeScheduleAdminEvent(key));
  }
  return data.sort((a, b) => a.date > b.date);
};

export const mergeWebSocketFreezes = (webSocketData, station, wopType, date, workgroup, fetchedRequests) => {
  const data = [...fetchedRequests];
  for (const [key, freezeWsEvent] of Object.entries(webSocketData)) {
    // Process only if the event is for the same station, wopType, date and workgroup admin/employee has selected
    if (
      freezeWsEvent.station === station &&
      freezeWsEvent.date === date &&
      freezeWsEvent.workgroup === workgroup &&
      freezeWsEvent.wopType === wopType
    ) {
      const idx = data.findIndex((freeze) => freeze.sk === freezeWsEvent.sk);
      if (idx !== -1) {
        const matchingFreeze = data[idx];
        // Condition to replace element in array if it already exists (update)
        if (parseInt(freezeWsEvent.createdAt) > parseInt(matchingFreeze.createdAt)) {
          data[idx] = freezeWsEvent;
        }
      } else {
        // New record
        data.unshift(freezeWsEvent);
      }
    }
    store.dispatch(removeFreezeEvent(key));
  }
  return data.sort((a, b) => (parseInt(b.createdAt) > parseInt(a.createdAt) ? 1 : -1));
};

export const mergeNotifications = (webSocketData, fetchedNotifications) => {
  const data = [...fetchedNotifications];
  for (const [key, notificationWsEvent] of Object.entries(webSocketData)) {
    if (!data.some((restNotification) => restNotification.id === notificationWsEvent.id)) {
      data.unshift(notificationWsEvent);
    }
    store.dispatch(removeNotificationEvent(key));
  }
  data.sort((a, b) => (parseInt(b.createdAt) > parseInt(a.createdAt) ? 1 : -1));
  return data;
};
